import { EDITOR_CONTENT_HTML_EMPTY, isEmptyHTML } from '@/app/util/editor/editor';
import { LANGUAGES_CONTENT } from '@/app/data/model_constants';

/**
 * Here you can find all the custom validators for our forms.
 */

const REGEX_EMAIL_ADDRESS =
  /^(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})$/;

const email = (email_address) =>
  _.isNil(email_address) || email_address === '' || REGEX_EMAIL_ADDRESS.test(email_address.trim());

const required_content_html = (value) => {
  if (isEmptyHTML(value)) return false;

  const strippedContent = value.replace(/<[^>]*>/g, '').trim();
  return strippedContent.length > 0;
};
const required_translated_content_html = (model, field) =>
  !_.isNil(
    _.find(LANGUAGES_CONTENT, (language) => {
      const value = _.get(model.attributes, `${field}_${language}`);
      return !_.isNil(value) && value !== EDITOR_CONTENT_HTML_EMPTY;
    }),
  );

export { email, required_content_html, required_translated_content_html };
